const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Basket+Details+API


function getBasketDetails() {
    const url = '/api/shopping-cart/basket';
    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = getBasketDetails;
